import { NumberQuizQuestion } from '@shared/types';
import { Pane, TextInput } from 'evergreen-ui';
import { FunctionComponent } from 'react';
import { Feedback } from '../../Feedback';
import { QuestionLabel } from '../../QuestionLabel';
import { BaseQuestionProps } from '../../types';

export type NumberQuestionProps = BaseQuestionProps & {
    question: NumberQuizQuestion;
};
export const NumberQuestion: FunctionComponent<NumberQuestionProps> = ({
    question,
    studentAnswers,
    setStudentAnswers,
    markedResult,
    quizDisabled,
    feedbackCorrect,
    feedbackWrong,
    onQuestionBlur,
}) => {
    return (
        <Pane key={question._id} marginY={15} onBlur={onQuestionBlur}>
            <QuestionLabel
                label={question.question}
                markedResult={markedResult}
                htmlFor={question._id}
            />
            <TextInput
                name={question.question}
                id={question._id}
                type="number"
                style={{ width: '100%' }}
                disabled={quizDisabled}
                value={(studentAnswers[question._id] as string) || ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudentAnswers({ ...studentAnswers, [question._id]: Number(e.target.value) })
                }
            />
            <Feedback feedbackCorrect={feedbackCorrect} feedbackWrong={feedbackWrong} />
        </Pane>
    );
};
